import { useMainContext } from '../callContext/MainContext'
import { accountPageText as text } from '../database/Text';
const ConfirmPopUp = ({showModel,setShowModel,handleYesClick}) => {
  const {language}=useMainContext();
  return (
    <>
   
    <div className={`absolute top-0 bg-black/70 z-[2000] h-screen w-full max-w-[500px] transition-opacity duration-500 ease-out flex justify-center items-center  ${!showModel?"opacity-0 -z-[1000]":" opacity-100"} `}>
    <div className=' yellow-theme-color p-4 w-5/6 rounded-md '>
      <h1 className='text-right text-white text-lg cursor-pointer font-extrabold -mt-2' onClick={ ()=>setShowModel(false)}>
        &#x2715;
        </h1>
      <div className='flex flex-col justify-center items-center my-3'>
      <h1 className='text-center w-3/4 text-bold'>{text.confirmationText?.[language]}</h1>
      <button className='p-2 rounded-md bg-white my-3 w-3/4' onClick={ ()=>setShowModel(false)}>{text.noBtnText?.[language]}</button>
      <button className='border-2 border-white p-2 rounded-md text-white w-3/4' onClick={handleYesClick}>{text.yesBtnText?.[language]}</button>
      </div>
    </div>
   </div>
    
    </>
  )
}

export default ConfirmPopUp